export enum Soundscape {
  None = 'None',
  Rain = 'Rain',
  Sea = 'Sea',
  Fire = 'Fire',
  JapaneseGarden = 'JapaneseGarden',
  Thunderstorm = 'Thunderstorm',
}
